module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/banco-inter-logo-7929d70dd8c4470134ab6c5c2c8fa734.svg";